import { EqlFieldName } from '@modules/common/constants';
import { SortBy } from '@modules/quantify/store/types';
import { EqlField } from 'generated/graphql';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface getOrderFunctionParams {
  groupBy: EqlField | undefined;
  sortBy: SortBy | null;
}

export function getCompareOrderFunction({
  groupBy,
  sortBy,
}: getOrderFunctionParams) {
  if (!groupBy?.field || !sortBy?.field) {
    return null;
  }

  const getOrderParams = () => {
    const order = sortBy.isAsc ? 'asc' : 'desc';

    switch (sortBy?.field) {
      case 'label': {
        if (
          groupBy.field === EqlFieldName.Entity ||
          groupBy.field === EqlFieldName.Reason ||
          groupBy.field === EqlFieldName.UserSentiment
        ) {
          return null;
        }

        return ['metadata-value', order];
      }
      case 'currValue':
        return ['inspect', order];
      case 'prevValue':
        return ['baseline', order];
      case 'absoluteDelta':
        return ['difference', order];
      case 'absValueDelta':
        return ['absolute-difference', order];
      default: {
        return null;
      }
    }
  };

  const params = getOrderParams();

  if (!params) {
    return null;
  }

  return {
    name: EQLFunctionName.DeltaOrder,
    params,
  };
}
